import $ from "jquery";
import recaptcha from "../recaptcha";

class Form {
  constructor(form) {
    this.form = form;
    this.post_id = form.post_id.value;

    this.submitButton = form.querySelector("button");

    this.successDiv = form.querySelector(".rf-success");
    this.errorDiv = form.querySelector(".rf-error");

    this.bindEvents();
    this.form.reset();
  }

  getSubmitUrl() {
    return `${ajax_url}?action=registration_form_submit_${this.type}`;
  }

  bindEvents() {
    this.form.addEventListener("submit", (e) => {
      this.submitted(e);
    });
  }

  submitted(e) {
    e.preventDefault();
    this.hideNotifications();
    this.disableSubmitButton();

    recaptcha().then((token) => {
      const data = this.getData();
      data.set("g-recaptcha-response", token);

      this.submit(data)
        .then(() => {
          this.showSuccess();
          this.form.reset();
        })
        .catch(() => {
          this.showError();
        })
        .always(() => {
          this.enableSubmitButton();
        });
    });
  }

  disableSubmitButton() {
    this.submitButton.disabled = true;
  }

  enableSubmitButton() {
    this.submitButton.disabled = false;
  }

  showSuccess() {
    this.successDiv.classList.remove("hidden");
  }

  hideSuccess() {
    this.successDiv.classList.add("hidden");
  }

  showError() {
    this.errorDiv.classList.remove("hidden");
  }

  hideError() {
    this.errorDiv.classList.add("hidden");
  }

  hideNotifications() {
    this.hideSuccess();
    this.hideError();
  }

  submit(data) {
    return $.ajax(this.getSubmitUrl(), {
      data,
      cache: false,
      contentType: false,
      processData: false,
      method: "POST",
      type: "POST",
    });
  }
}

export default Form;
